const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  hasMoreItems: false,
  offset: 0,
  limit: 20,
  directorySelectedOrg: null,
  error: null,
  nbResult: 0,
  cachedState: null
};
export const directoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_DIRECTORIES_LIST": {
      return initialState;
    }
    case "RESET_RESOURCES": {
      return { ...initialState };
    }
    case "SET_DIRECTORY_SELECTED_ORG": {
      return {
        ...state,
        directorySelectedOrg: action.org
      };
    }
    case "RESET_DIRECTORY_SELECTED_ORG": {
      return { ...state, directorySelectedOrg: null };
    }
    case "FETCH_DIRECTORIES_PENDING": {
      return { ...state, fetched: false, fetching: true, items: [], offset: 0 };
    }
    case "SET_FETCHING": {
      return { ...state, fetching: action.payload };
    }
    case "FETCH_DIRECTORIES_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case "FETCH_DIRECTORIES_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "FETCH_INFINITE_DIRECTORIES_PENDING": {
      return { ...state, fetched: false, fetching: true, hasMoreItems: true };
    }
    case "FETCH_INFINITE_DIRECTORIES_FULFILLED": {
      const { data = [], nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMoreItems: data.length >= state.limit,
        offset: state.offset + state.limit,
        error: null,
        items: state.items.concat(data),
        nbResult: nbResult
      };
    }
    case "FETCH_INFINITE_DIRECTORIES_REJECTED": {
      let error = action.payload;

      if (error && error.response && error.response.status) {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        hasMoreItems: false,
        error
      };
    }
    case "SAVE_DIRECTORY_STATE_TO_CACHE": {
      return {
        ...initialState,
        directorySelectedOrg: state.directorySelectedOrg,
        cachedState: {
          ...state
        }
      };
    }
    case "RESTORE_DIRECTORY_STATE_FROM_CACHE": {
      return {
        ...state.cachedState,
        directorySelectedOrg: state.directorySelectedOrg,
        cachedState: null
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/directory.js